<template>
    <div>
        <div class="current_time">{{ currentTime }}</div>
        <el-card>
            <p class="title_p">基本信息</p>
            <ul class="dis_flex">
                <li v-for="(item,index) in BmsList" :key="index">
                    <p>{{ item.tag || 0 }}</p>
                    <p class="schedule">
                        <span :style="{width: item.soc + '%'}"></span>
                    </p>
                    <p>SOC: {{ item.soc + '%' }}</p>
                </li>
            </ul>
            <div class="dis_flex">
                <el-form class="dis_flex_div" v-for="(item,index) in BmsList" :key="index">
                    <el-form-item label="电压：" label-width="120px">{{ item.voltage || 0 }} V</el-form-item>
                    <el-form-item label="电流：" label-width="120px">{{ item.current || 0 }} A</el-form-item>
                    <el-form-item label="功率：" label-width="120px">{{ item.power || 0 }} KW</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">PCS状态</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" >
                    <el-form-item label="pcs编号：" label-width="120px"></el-form-item>
                    <el-form-item label="状态：" label-width="120px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item>PCS {{ item.pcsNo || 0 }} #</el-form-item>
                    <el-form-item>{{ stateList[(item.state || 0)] }}</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">电压</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" >
                    <el-form-item label="电压：" label-width="120px"></el-form-item>
                    <el-form-item label="电流：" label-width="120px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item >{{ item.batteryVoltage || 0 }} V</el-form-item>
                    <el-form-item>{{ item.batteryElectric || 0 }} A</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">温度</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" >
                    <el-form-item label="IGBT：" label-width="120px"></el-form-item>
                    <el-form-item label="环境：" label-width="120px"></el-form-item>
                    <el-form-item label="电感：" label-width="120px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item >{{ item.igbtTemp || 0 }} °C</el-form-item>
                    <el-form-item>{{ item.ambientTemp || 0 }} °C</el-form-item>
                    <el-form-item>{{ item.inductanceTemp || 0 }} °C</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">电网</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" >
                    <el-form-item label="频率：" label-width="120px"></el-form-item>
                    <el-form-item label="相序：" label-width="120px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item >{{ item.frequency || 0 }}</el-form-item>
                    <el-form-item>{{ item.gridPhaseSeq || 0 }}</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">直流</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" >
                    <el-form-item label="功率：" label-width="120px"></el-form-item>
                    <el-form-item label="总电流：" label-width="120px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item >{{ item.dcPower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.totalDcElectric || 0 }} A</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">交流</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" >
                    <el-form-item label="功率因数：" label-width="120px"></el-form-item>
                    <el-form-item label="总有功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="总无功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="总视在功率：" label-width="120px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item >{{ item.acPowerFactor || 0 }}</el-form-item>
                    <el-form-item>{{ item.acOutputTotalActivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acOutputTotalReactivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acOutputTotalApparentPower || 0 }} KW</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p">交流ABC项</p>
            <div class="dis_flex">
                <el-form class="dis_flex_div" >
                    <el-form-item label="A有功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="B有功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="C有功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="A无功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="B无功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="C无功功率：" label-width="120px"></el-form-item>
                    <el-form-item label="A视在功率：" label-width="120px"></el-form-item>
                    <el-form-item label="B视在功率：" label-width="120px"></el-form-item>
                    <el-form-item label="C视在功率：" label-width="120px"></el-form-item>
                    <el-form-item label="A相电压：" label-width="120px"></el-form-item>
                    <el-form-item label="B相电压：" label-width="120px"></el-form-item>
                    <el-form-item label="C相电压：" label-width="120px"></el-form-item>
                    <el-form-item label="A相电流：" label-width="120px"></el-form-item>
                    <el-form-item label="B相电流：" label-width="120px"></el-form-item>
                    <el-form-item label="C相电流：" label-width="120px"></el-form-item>
                    <el-form-item label="AB相电压：" label-width="120px"></el-form-item>
                    <el-form-item label="BC相电压：" label-width="120px"></el-form-item>
                    <el-form-item label="CA相电压：" label-width="120px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item >{{ item.acPhaseAActivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseBActivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseCActivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseAReactivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseBReactivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseCReactivePower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseAApparentPower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseBApparentPower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.acPhaseCApparentPower || 0 }} KW</el-form-item>
                    <el-form-item>{{ item.outletVoltageA || 0 }} V</el-form-item>
                    <el-form-item>{{ item.outletVoltageB || 0 }} V</el-form-item>
                    <el-form-item>{{ item.outletVoltageC || 0 }} V</el-form-item>
                    <el-form-item>{{ item.outletElectricA || 0 }} A</el-form-item>
                    <el-form-item>{{ item.outletElectricB || 0 }} A</el-form-item>
                    <el-form-item>{{ item.outletElectricC || 0 }} A</el-form-item>
                    <el-form-item>{{ item.outletVoltageAb || 0 }}  V</el-form-item>
                    <el-form-item>{{ item.outletVoltageBc || 0 }} V</el-form-item>
                    <el-form-item>{{ item.outletVoltageCa || 0 }} V</el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card>
            <p class="title_p" @click="moreChange = !moreChange" style="cursor: pointer;">更多</p>
            <div class="dis_flex" v-show="moreChange">
                <el-form class="dis_flex_div" >
                    <el-form-item label="电池过压保护点" label-width="180px"></el-form-item>
                    <el-form-item label="电池欠压保护点" label-width="180px"></el-form-item>
                    <el-form-item label="母线故障字" label-width="180px"></el-form-item>
                    <el-form-item label="母线故障原因" label-width="180px"></el-form-item>
                    <el-form-item label="电池恒压充电电压" label-width="180px"></el-form-item>
                    <el-form-item label="当前实际充放电工作模式" label-width="180px"></el-form-item>
                    <el-form-item label="EMS通讯故障阈值" label-width="180px"></el-form-item>
                    <el-form-item label="电网故障字" label-width="180px"></el-form-item>
                    <el-form-item label="电网故障原因" label-width="180px"></el-form-item>
                    <el-form-item label="硬件故障字1" label-width="180px"></el-form-item>
                    <el-form-item label="硬件故障字1原因" label-width="180px"></el-form-item>
                    <el-form-item label="硬件故障字2" label-width="180px"></el-form-item>
                    <el-form-item label="硬件故障字2原因" label-width="180px"></el-form-item>
                    <el-form-item label="负母线电压" label-width="180px"></el-form-item>
                    <el-form-item label="其它故障字" label-width="180px"></el-form-item>
                    <el-form-item label="电感A相电流" label-width="180px"></el-form-item>
                    <el-form-item label="电感B相电流" label-width="180px"></el-form-item>
                    <el-form-item label="电感C相电流" label-width="180px"></el-form-item>
                    <el-form-item label="正母线电压" label-width="180px"></el-form-item>
                    <el-form-item label="ReModbus地址" label-width="180px"></el-form-item>
                    <el-form-item label="ReModbus波特率" label-width="180px"></el-form-item>
                    <el-form-item label="无功电流补偿电流设置" label-width="180px"></el-form-item>
                    <el-form-item label="无功功率补偿功率设置" label-width="180px"></el-form-item>
                    <el-form-item label="无功补偿功率因数" label-width="180px"></el-form-item>
                    <el-form-item label="无功补偿方式设置" label-width="180px"></el-form-item>
                    <el-form-item label="状态" label-width="180px"></el-form-item>
                    <el-form-item label="系统故障字" label-width="180px"></el-form-item>
                    <el-form-item label="总母线电压" label-width="180px"></el-form-item>
                    <el-form-item label="直流总电流" label-width="180px"></el-form-item>
                    <el-form-item label="恒流转恒压充电电池电压点" label-width="180px"></el-form-item>
                </el-form>
                <el-form class="dis_flex_div" v-for="(item,index) in PcsList" :key="index">
                    <el-form-item>{{ item.batteryOvervoltageProtectionPoInteger || 0 }}</el-form-item>
                    <el-form-item>{{ item.batteryUndervoltageProtectionPoInteger || 0 }} </el-form-item>
                    <el-form-item>{{ item.busFault || 0 }} </el-form-item>
                    <el-form-item>{{ busFaultsList[(item.busFault || 0 )]}} </el-form-item>
                    <el-form-item>{{ item.constantVoltageChargeVoltage || 0 }}</el-form-item>
                    <el-form-item>{{ dischargeModeList[(item.dischargeMode || 0 )]}} </el-form-item>
                    <el-form-item>{{ item.emsCommThreshold || 0 }}</el-form-item>
                    <el-form-item>{{ item.gridFault || 0 }}</el-form-item>
                    <el-form-item>{{ gridFaultsList[(item.gridFault || 0 )]}}</el-form-item>
                    <el-form-item>{{ item.hardwareFault1 || 0}}</el-form-item>
                    <el-form-item>{{ hardwareFault1sList[(item.hardwareFault1 || 0 )]}}</el-form-item>
                    <el-form-item>{{ item.hardwareFault2s || 0}}</el-form-item>
                    <el-form-item>{{ hardwareFault2sList[(item.hardwareFault2 || 0 )]}}</el-form-item>
                    <el-form-item>{{ item.negativeBusVoltage || 0 }}</el-form-item>
                    <el-form-item>{{ otherFaultsList[item.otherFault || 5] }}</el-form-item>
                    <el-form-item>{{ item.outletInductanceA || 0 }} A</el-form-item>
                    <el-form-item>{{ item.outletInductanceB || 0 }} A</el-form-item>
                    <el-form-item>{{ item.outletInductanceC || 0 }} A</el-form-item>
                    <el-form-item>{{ item.positiveBusVoltage || 0 }} V</el-form-item>
                    <el-form-item>{{ item.reModbusAddress || 0 }}</el-form-item>
                    <el-form-item>{{ item.reModbusBaud || 0 }}</el-form-item>
                    <el-form-item>{{ item.reactiveEletricCompensation || 0 }}</el-form-item>
                    <el-form-item>{{ item.reactivePowerCompensation || 0 }}</el-form-item>
                    <el-form-item>{{ item.reactivePowerCompensationFactor || 0 }}</el-form-item>
                    <el-form-item>{{ reactivePowerCompensationModeList[item.reactivePowerCompensationMode || 0] }}</el-form-item>
                    <el-form-item>{{ stateList[item.state || 0] }}</el-form-item>
                    <el-form-item>{{ systemFaultList[item.systemFault || 14] }}</el-form-item>
                    <el-form-item>{{ item.totalBusVoltage || 0 }} V</el-form-item>
                    <el-form-item>{{ item.totalDcElectric || 0 }} A</el-form-item>
                    <el-form-item>{{ item.voltagePoIntegerConstantEletricToConstantVoltage || 0 }}</el-form-item>
                </el-form>
            </div>
        </el-card>
    </div>
</template>
<script>

import { AxiosAjax, addDate } from '../../js/axios.config';
export default {
    data() {
        return {
            currentTime:'',
            moreChange: false,
            initTime:'' ,
            initDateTime: '',
            BmsList: [],
            PcsList: [],
            stateList: ['待机','运行','故障'],
            busFaultsList: [
                '预充母线过压', '预充母线欠压', '不控整流母线过压', '不控整流母线欠压', '运行母线过压', '运行母线欠压', '母线不平衡', '电池欠压', '电流模式母线欠压', '电池过压'
            ],
            dischargeModeList: [
                '电池恒压','并网恒流','电池恒流'
            ],
            gridFaultsList: [
                'A相过压故障', 'B相过压故障', 'C相过压故障', 'A相欠压故障', 'B相欠压故障', 'C相欠压故障', '电网过频', '电网欠频', '电网相序错误', 'A相软件过流', 'B相软件过流', 'C相软件过流', '电网电压不平衡', '电网电流不平衡', '电网缺相', 'N线过流'
            ],
            hardwareFault1sList:[
                'EPO故障', 'IGBT硬件过流', '母线硬件过压', '功率模块1硬件过流'
            ],
            hardwareFault2sList: [
                '辅助电源故障', '风扇故障', '连接故障', '交流测熔丝损坏', '交流防雷器故障', '功率模块过温'
            ],
            otherFaultsList: {
                '5': '系统谐振故障', 
                '6': '软件过压过流', 
                '7': 'A相输出过载',
                '8': 'B相输出过载', 
                '9': 'C相输出过载',
                '10': '电池过压',
                '11' :'电池过流'
            },
            reactivePowerCompensationModeList: [
                '无功电流模式','功率因数模式', '无功功率模式'
            ],
            systemFaultList: {
                '14': '从模块CAN通信故障',
                 '15': 'EMS 通信故障'
            }

        }
    },
    beforeDestroy(){
        const _that = this
        clearInterval(_that.initTime);
        clearInterval(_that.initDateTime);
    },
    mounted() {
        const _that = this
		_that.init();
        _that.initTime = setInterval(function() {
            _that.init();
        }, 180000)
        _that.initDateTime = setInterval(function() {
            _that.initDate();
        },8000)

		
				
    },
    methods: {
        init() {
            const _this = this
            const params = {
                cabinetCode: _this.$route.query.cabinetCodes,
                minute: 3,
                module: 3
            }
            AxiosAjax({
                method: 'post',
                url: '/cabinet/cabinet/setPublish',
                data: params,
                success: function (res) {
                    _this.initDate()
                }
            });
        },
        initDate() {
            const _this = this
            this.id = this.$route.query.id || '';

            AxiosAjax({
                url: '/cabinet/bms/'+ this.id,
                success: function (res) {
                    _this.BmsList = []
                    if(res.data.data.length != 0) {
                        _this.currentTime = res.data.data[0].deviceTime
                        res.data.data.forEach((r,i) => {
                            if (i != 0) {
                                _this.BmsList.push(r)
                            }
                        })
                    }
                }
            });
            //日统计
            AxiosAjax({
                url: '/cabinet/pcs/'+ this.id,
                success: function (res) {
                    _this.PcsList = [];
                    if(res.data.data.length != 0) {
                        res.data.data.forEach((r,i) => {
                            if (i != 0) {
                                _this.PcsList.push(r)
                            }
                        })
                    }
                }
            });
        }
	}
}
</script>
<style scoped>
.current_time {
    position: absolute;
    top:-36px;
    right: 16px;
}
.dis_flex {
    display: flex;
    padding: 0 40px;
}
li {
    flex: 1;
    text-align: left;
}
.dis_flex_div {
    flex: 1;
}
.el-card {
    margin: 10px;
}
.dis_flex_div /deep/ .el-form-item__content {
    text-align: left;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.dis_flex_div /deep/ .el-form-item__label {
    text-align: left;
}
.dis_flex_div /deep/ .el-form-item {
    margin-bottom: 0;
}
.title_p {
    text-align: left;
    border-bottom: 1px solid #ccc;
    margin-bottom: 20px;
    padding-bottom: 16px;
    font-weight: 600;
}
.schedule {
    width: 100px;
    height: 30px;
    background: #ccc;
    margin: 10px auto;
    margin-left: 0;
}
.schedule span {
    display: block;
    background: yellowgreen;
    height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Monitor/Pcs.vue